import { SET_ENLIGHTEN_MANAGER_TOKEN } from "../../Constants/ActionTypes"

let initialState = {
  enlightenManagerToken: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ENLIGHTEN_MANAGER_TOKEN:
      return { ...state, enlightenManagerToken: action.enlightenManagerToken }
    default:
      return state
  }
}

export default reducer